import script from "./IInput.vue?vue&type=script&setup=true&lang=js"
export * from "./IInput.vue?vue&type=script&setup=true&lang=js"

import "./IInput.vue?vue&type=style&index=0&id=8c37fa3e&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c37fa3e"]])

export default __exports__